import * as React from 'react';
import { useUIFacade } from '../../../../../ui/facades/ui.facade';
import LinkTemplate from '../../../../../ui/templates/columns/LinkTemplate';
import TrueFalseTemplate from '../../../../../ui/templates/columns/TrueFalseTemplate';
import ValueTemplate from '../../../../../ui/templates/columns/ValueTemplate';
import PrwcDataTableAdvanced from '../../../../../ui/widgets/custom/PrwcDataTableAdvanced';

const ShiftCodeList = (props: any) => {
  const { onEdit } = props;
  const uiFacade = useUIFacade();

  const handleOnDelete = (rowData: any) => {
    uiFacade.showConfirmDeleteDialog(rowData, deleteShiftCode);
  }

  const deleteShiftCode = (rowData: any) => {
    console.log('delete group --');
    console.log(rowData);
  }

  const editShiftCode = (rowData: any) => {
    console.log('edit group ---');
    console.log(rowData);
    onEdit(rowData);
  }

  const data = [
    {
      shiftCode: "WO",
      shiftName: "Week Off",
      abbreviation: "Week off abbreviation",
      applyToRoster: true,
    },
    {
      shiftCode: "AB",
      shiftName: "Absent",
      abbreviation: "Absent abbreviation",
      applyToRoster: false
    },
    {
      shiftCode: "WO",
      shiftName: "Week Off",
      abbreviation: "Week off abbreviation",
      applyToRoster: true,
    },
    {
      shiftCode: "AB",
      shiftName: "Absent",
      abbreviation: "Absent abbreviation",
      applyToRoster: false
    },
    {
      shiftCode: "WO",
      shiftName: "Week Off",
      abbreviation: "Week off abbreviation",
      applyToRoster: true,
    },
    {
      shiftCode: "AB",
      shiftName: "Absent",
      abbreviation: "Absent abbreviation",
      applyToRoster: false
    },
    {
      shiftCode: "WO",
      shiftName: "Week Off",
      abbreviation: "Week off abbreviation",
      applyToRoster: true,
    },
    {
      shiftCode: "AB",
      shiftName: "Absent",
      abbreviation: "Absent abbreviation",
      applyToRoster: false
    },
    {
      shiftCode: "WO",
      shiftName: "Week Off",
      abbreviation: "Week off abbreviation",
      applyToRoster: true,
    },
    {
      shiftCode: "AB",
      shiftName: "Absent",
      abbreviation: "Absent abbreviation",
      applyToRoster: false
    },
    {
      shiftCode: "WO",
      shiftName: "Week Off",
      abbreviation: "Week off abbreviation",
      applyToRoster: true,
    },
    {
      shiftCode: "AB",
      shiftName: "Absent",
      abbreviation: "Absent abbreviation",
      applyToRoster: false
    },
 
  ];

  const dataTable = {
    columns: [
      {
        field: "shiftCode",
        headerLabelKey: "shiftDetails.label.shiftCode",
        bodyTemplate: LinkTemplate,
        className: "w-10 text-xs",
        sortable: true,
        command: (rowData: any) => {
          editShiftCode(rowData);
        }
      },
      {
        field: "shiftName",
        headerLabelKey: "shiftDetails.label.shiftName",
        bodyTemplate: ValueTemplate,
        className: "w-20 text-xs",
        sortable: true
      },
      {
        field: "abbreviation",
        headerLabelKey: "shiftDetails.label.abbreviation",
        bodyTemplate: ValueTemplate,
        className: "w-16 text-xs",
        sortable: true
      },
      {
        field: "applyToRoster",
        headerLabelKey: "shiftDetails.label.applyToRoster",
        bodyTemplate: TrueFalseTemplate,
        className: "w-16 text-xs",
        sortable: true
      }
    ],
  };

  return (
    <div>
      <PrwcDataTableAdvanced
        data={data}
        columns={dataTable.columns}
        paginator={true}
        onEdit={editShiftCode}
        onDelete={handleOnDelete}
      ></PrwcDataTableAdvanced>
    </div>
  );
};

export default ShiftCodeList;
